export const RoleToLinkMapper = (role) => {
  switch (role) {
    case "Volunteer":
      return "/careprovider/";
    case "Volunteer Coordinator":
      return "/carecoordinator/";
    case "Patient":
      return "/careconsumer/";
    default:
      return "/error?code=1002";
  }
};
